import * as React from 'react';
import { WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { Draggable } from '@edorivai/react-smooth-dnd';

import { StateType } from '../../reducers';
import { EditorTab as EditorTabType } from '../../reducers/EditorReducer/EditorReducer.types';
import { flashMessagesEditorCodeMessageSelector } from '../../reducers/FlashMessageReducer/FlashMessageSelector';

import { EditorTab } from './';
import { ListEditorTabProps, ListEditorTabStateProps } from './types';

export const ListEditorTabMain = ({
  currentTabs,
  handleCloseTab,
  handleSetTabAsActive,
  progress,
  currentActiveTab,
  calculateProgress = false,
  handleRenameTab,
  handleDisableRename,
  canRename,
  renameInfo,
  isChild,
  parentTabIndex,
  currentParentTab,
  handleDropdownMenuClose,
  tabsWidth,
  updateTabWidth,
  tabsStatus,
  intl,
  checkIfTabHasAlpha,
  changeSimulationStatus,
}: ListEditorTabProps & ListEditorTabStateProps & InjectedIntlProps) => (
  <React.Fragment>
    {currentTabs.map((currentTab: EditorTabType, currentIndex: number) => {
      const handlerOnCloseClick = (event: React.SyntheticEvent<HTMLSpanElement>) => {
        event.stopPropagation();
        handleCloseTab(currentIndex);
        if (updateTabWidth) {
          updateTabWidth();
        }
      };
      const setTabAsActive = () => {
        handleSetTabAsActive(currentIndex);
        if (handleDropdownMenuClose) {
          handleDropdownMenuClose();
        }
      };
      const tabActive = currentIndex === currentActiveTab;

      const tabStatus = isChild
        ? tabsStatus.getIn([parentTabIndex, 'childTabs', currentIndex, 'currentStatus'])
        : tabsStatus.getIn([currentIndex, 'parentTab', 'currentStatus']);

      const progressResult = calculateProgress === false ? progress : progress.getIn([currentIndex, 'percentageProgress']);

      return (
        // @ts-expect-error react-beautiful-dnd Draggable render-prop typing mismatch
        <Draggable key={`tab-${currentIndex}`}>
          <EditorTab
            key={`tab-${currentIndex}`}
            // @ts-expect-error ImmutableJS getIn returns unknown
            multi={currentTabs.getIn([currentIndex, 'childTabs'])}
            isSuperAlpha={currentTab.get('superAlpha')}
            active={tabActive}
            tabName={currentTab.get('tabName')}
            onActivateClickHandler={setTabAsActive}
            onCloseClickHandler={handlerOnCloseClick}
            progress={progressResult}
            handleRenameTab={handleRenameTab}
            handleDisableRename={handleDisableRename}
            canRename={canRename && renameInfo && renameInfo.index === currentIndex && renameInfo.isChild === isChild}
            currentIndex={currentIndex}
            isChild={isChild}
            hasAlpha={checkIfTabHasAlpha(currentTab, currentIndex, currentParentTab)}
            tabWidth={tabsWidth}
            updateTabWidth={updateTabWidth}
            // @ts-expect-error EditorTab own-props collapse under @types/react@19
            tabStatus={tabStatus}
            intl={intl}
          />
        </Draggable>
      );
    })}
  </React.Fragment>
);

const mapStateToProps = (state: StateType) => ({
  flashMessages: flashMessagesEditorCodeMessageSelector(state),
});

// @ts-expect-error connect TOwnProps=any collapses own-props under @types/react@19
export const ListEditorTab = connect<ListEditorTabStateProps, {}, any, StateType>(mapStateToProps, {})(ListEditorTabMain);
